// extracted by mini-css-extract-plugin
module.exports = {"embed_wrapper":"youtube-embed-modal_embed_wrapper__Dnzry","iframe":"youtube-embed-modal_iframe__yAK_v"};